












































import {
  Vue,
  Component,
  Prop,
  Watch,
} from "@/shared/vuepack";
import {
  UserPermission,
} from "@/shared/types";
import VueRouter from "vue-router";
import { Validator } from "vee-validate";
import { useSalesPersonStore } from "@/admin/store/salesPerson";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";
import { useRolePermissionsStore } from "@/shared/store/rolePermissions";


@Component
export default class EditSalesPerson extends Vue {
  $router: VueRouter;
  $validator: Validator;

  salesPersonStore = useSalesPersonStore();
  featureFlagStore = useFeatureFlagStore();
  rolePermissionsStore = useRolePermissionsStore();

  @Prop() salesPersonId: number;

  model = {
    salesPersonId: 0,
    firstName: "",
    lastName: "",
    isActive: true
  };

  mounted (): void {
    this.salesPersonStore.getSalesPersons()
        .then(x => {
          this.setSalesPersonModel();
        });
  }

  get hasEditPermission (): boolean {
    return this.featureFlagStore.flags.hsa4475allowRolePermissions
        ? this.rolePermissionsStore.userHasAdminPermission(UserPermission.AdminPortalEmployerEdit)
        : true;
  }

  setSalesPersonModel (): void {
    if (this.salesPersonId) {
      const salesPerson = this.salesPersonStore.salesPersonById(this.salesPersonId);
      if (salesPerson !== null) {
        this.model = {
          salesPersonId: salesPerson.salesPersonId,
          firstName: salesPerson.firstName,
          lastName: salesPerson.lastName,
          isActive: salesPerson.isActive
        };
      }
    }
  }

  @Watch("salesPersonStore.salesPersons", { deep: true })
  updateSalesPersonModel (): void {
    this.setSalesPersonModel();
  }

  submit (): void {
    this.$validator.validateAll().then(result => {
      if (!result) {
        return;
      }
      if (this.salesPersonStore.isPosting) {
        return;
      }
      this.salesPersonStore.saveSalesPerson(this.model);
      this.model = {
        salesPersonId: 0,
        firstName: "",
        lastName: "",
        isActive: true
      };
    });
  }
}
